export default __webpack_public_path__ + "static/media/otabek.6b13a445.png";